import Header from "@/components/hotel/Header";
import SubpageHero from "@/components/hotel/SubpageHero";
import DoubleRoom from "@/components/hotel/DoubleRoom";
import Footer from "@/components/hotel/Footer";
import SEO, { BASE_URL } from "@/components/SEO";
import { useLanguage } from "@/i18n/LanguageContext";

const DoubleRoomPage = () => {
  const { t } = useLanguage();
  return (
    <main id="main-content" className="min-h-screen bg-background">
      <SEO
        title="Doppelzimmer"
        description="Elegantes Doppelzimmer im ESOS Hotel Quelle Bad Ragaz – perfekt für Paare und Geschäftsreisende."
        breadcrumbs={[
          { name: "Home", path: "/" },
          { name: "Zimmer", path: "/rooms" },
          { name: "Doppelzimmer", path: "/rooms/double" },
        ]}
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "HotelRoom",
          name: "Doppelzimmer",
          description: "Elegantes Doppelzimmer mit Doppelbett und eigenem Bad.",
          url: `${BASE_URL}/rooms/double`,
          bed: [
            { "@type": "BedDetails", typeOfBed: "Doppelbett", numberOfBeds: 1 },
          ],
          occupancy: { "@type": "QuantitativeValue", minValue: 1, maxValue: 2 },
          amenityFeature: [
            { "@type": "LocationFeatureSpecification", name: "WLAN", value: true },
            { "@type": "LocationFeatureSpecification", name: "TV", value: true },
            { "@type": "LocationFeatureSpecification", name: "Eigenes Bad", value: true },
            { "@type": "LocationFeatureSpecification", name: "Parkplatz", value: true },
          ],
        }}
      />
      <Header />
      <SubpageHero title={t.subpageHeroes.doubleRoom.title} subtitle={t.subpageHeroes.doubleRoom.subtitle} />
      <DoubleRoom />
      <Footer />
    </main>
  );
};

export default DoubleRoomPage;
